import { render, staticRenderFns } from "./servieItemDetail.vue?vue&type=template&id=0a2da5ca&scoped=true&"
import script from "./servieItemDetail.vue?vue&type=script&lang=ts&"
export * from "./servieItemDetail.vue?vue&type=script&lang=ts&"
import style0 from "./servieItemDetail.vue?vue&type=style&index=0&id=0a2da5ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2da5ca",
  null
  
)

export default component.exports